import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
// import { RaiseATicket, RaiseTicketWithDocument, TicketChatboxModal } from "./TicketsComponents";
import { DownloadIcon, Eye, Filter, SearchBig, AddwithWhiteCircle, Attachment } from "../AllSvg";
import { formatDate, formattedDate, formatDateTime, formattedDateLong } from "../Date";
import { BASE_URL, IMAGE_URL, TESTING_URL } from "../../config/axios";
// import { customSortByKey, downloadAsExcel, formatCurrencyIndian, formatRoundoff2D, handleErrorToast, ViewChatImageorFile, DateRangePicker } from "../CustomFunctions";
import { useLocation, useNavigate } from "react-router-dom";
import Dashboardnavbar from '../../layout/Dashboardnavbar';
import { Modal } from "react-bootstrap";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { DateRangePicker, handleErrorToast, ViewChatImageorFile } from "../custom";
import { TicketChatboxModal } from "./ChatBox";
// import TicketChatboxModal from "./ChatBox"

const RaiseATicket = ({ getTicketList }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
        setFormData({
            title: "",
            description: "",
            assign_date: formattedDate,
            due_date: null,
            assigned_by_name: sessionStorage.getItem("name") || "",
            assigned_by: sessionStorage.getItem("email") || "",
            status: "pending",
            ticket_for: "PMS",
        })
        setDocumentData({
            document: null,
            timestamp: new Date().toISOString(),
            ticket: "",
            sender: "",
            message: "",
            image: '',
            sender_name: "",
            ticket_name: "",
            ticketaccepted_by_email: "",
            ticketaccepted_by_name: "",
            ticket_for_productname: "PMS",
            read_status: false,

        })

        setFileName("");
    }
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        title: "",
        description: "",
        assign_date: formattedDate,
        due_date: null,
        assigned_by_name: sessionStorage.getItem("name") || "",
        assigned_by: sessionStorage.getItem("email") || "",
        status: "pending",
        ticket_for: "PMS",

    });

    const [documentData, setDocumentData] = useState({
        document: null,
        timestamp: new Date().toISOString(),
        ticket: "",
        sender: "",
        message: "",
        image: '',
        sender_name: "",
        ticket_name: "",
        ticketaccepted_by_email: "",
        ticketaccepted_by_name: "",
        ticket_for_productname: "",
        read_status: false,
    });
    useEffect(() => {
        setDocumentData((prev) => ({
            ...prev,
            ticket_name: formData.title,
            ticket_for_productname: formData.ticket_for,
            ticketaccepted_by_email: formData.assigned_by,
            ticketaccepted_by_name: formData.assigned_by_name,
            sender: formData.assigned_by,
            sender_name: formData.assigned_by_name,


        }))
    }, [formData.ticket_for, formData.title, formData.assigned_by, formData.assigned_by_name, documentData.document]);





    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "title",
            "description",
            "assign_date",
            // "due_date",
            // "assigned_by_name",
            "assigned_by",
            // "ticket_for"
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (validateForm()) {

            setLoading(true); //loading logic
            const formDataToSend = new FormData();
            Object.keys(documentData).forEach((key) => {
                if (documentData[key] && key !== "document") {
                    formDataToSend.append(key, documentData[key]);
                }
            });

            const symbols = '!@#$%^&*()_-+=';
            const lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz';
            const uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            const numbers = '0123456789';
            const now = new Date();
            let date = now.toLocaleDateString('en-GB').split('/').reverse().join('-'); // Format: YYYY-MM-DD
            let time = now.toLocaleTimeString('en-GB', { hour12: false }).replace(/:/g, '-'); // Format: HH-MM-SS
            const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
            let randomCode = '';
            for (let i = 0; i < 8; i++) {
                const randomIndex = Math.floor(Math.random() * allChars.length);
                randomCode += allChars[randomIndex];
            }

            let originalFile, customFileName, customFile;
            if (documentData.document) {
                originalFile = documentData.document;
                customFileName = `Aimantra ${date} ${time}_${randomCode} ${originalFile.name}`;
                customFile = new File([originalFile], customFileName, { type: originalFile.type });
                formDataToSend.append("document", customFile);
            }

            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(`${BASE_URL}/ticket/ticket/`, formData);

                if (res.status === 200) {
                    const getid = res.data.id;

                    // If file exists, send it separately with ticket ID
                    if (documentData.document) {
                        formDataToSend.append("ticket", getid);
                        await axios.post(`${BASE_URL}/ticket/ticketChat/`, formDataToSend, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        });
                    }
                    await getTicketList();
                    handleClose();
                } else {
                    alert(res);
                }
            } catch (err) {
                // handleErrorToast(err, loadingToastId);
                console.log(err);

            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };
    const [fileName, setFileName] = useState("");

    const handleFileChange = (e) => {
        const { name, value } = e.target;
        const file = e.target.files[0];

        if (file) {
            setDocumentData({ ...documentData, [name]: file, });
            setFileName(file.name);
        } else {
            setFileName("");
        }

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }

    };

    const handleClear = () => {
        setDocumentData(prevState => ({
            ...prevState,
            document: null
        }));
        setFileName("");

    }








    useEffect(() => {
        const currentUrl = window.location.href;
        const urlParts = currentUrl.split("/");
        const FRONTEND_URL = urlParts[0] + `//` + urlParts[2];

        const domainParts = urlParts[2].split(".");
        console.log(domainParts, FRONTEND_URL, 'frontend url');

        if (FRONTEND_URL.includes('hrms')) {
            setFormData({
                ...formData,
                ticket_for: "Aimantra HRMS",
            });
        } else if (FRONTEND_URL.includes('csms')) {
            setFormData({
                ...formData,
                ticket_for: "Aimantra CSMS",
            });
        }
    }, [])

    console.log(formData)



    return (
        <>
            <button
                title="Raise a New Request"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> New Ticket
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Raise a Ticket Request</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div title="Title" className="flex-column">
                                <label
                                    htmlFor="title"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Title<span className="required">*</span>
                                </label>
                                <input
                                    id="title"
                                    type="text"
                                    name="title"
                                    maxLength={300}
                                    placeholder="Enter Title"
                                    onChange={handleInputChange}
                                    value={formData.title}
                                    className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""
                                        }`}
                                />
                                {errors.title && (
                                    <span className="error-message">{errors.title}</span>
                                )}
                            </div>


                            <div title="Ticket For" className="flex-column">
                                <label
                                    htmlFor="ticket_for"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Ticket For<span className="required">*</span>
                                </label>
                                <input
                                    id="ticket_for"
                                    type="text"
                                    name="ticket_for"
                                    maxLength={300}
                                    placeholder="Enter Ticket For"
                                    onChange={handleInputChange}
                                    value={formData.ticket_for}
                                    className={`form-input ${errors.ticket_for ? "error" : inputState.ticket_for ? "success" : ""
                                        }`}

                                    readOnly
                                />
                                {errors.ticket_for && (
                                    <span className="error-message">{errors.ticket_for}</span>
                                )}
                            </div>
                            {/* 
                            <div className="flex-column">
                                <label
                                    htmlFor="ticket_for"
                                    className="form-labels font-weight500 font-size-subheading">
                                    Ticket For<span className="required">*</span>
                                </label>
                                <select
                                    id="ticket_for"
                                    name="ticket_for"
                                    className="form-input"
                                    defaultValue=""
                                >
                                    <option value="" disabled hidden>
                                        Ticket For
                                    </option>
                                    
                                    <option value="">AiMantra PROJECT MANAGEMENT SYSTEM</option>
                                </select>
                                {errors.ticket_for && (
                                    <span className="error-message">{errors.ticket_for}</span>
                                )}

                            </div> */}


                            <div title="Description" className="flex-column">
                                <label
                                    htmlFor="description"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Description<span className="required">*</span>
                                </label>
                                <textarea
                                    id="description"
                                    name="description"
                                    placeholder="Enter Description"
                                    onChange={handleInputChange}
                                    value={formData.description}
                                    className={`form-input-textarea ${errors.description
                                        ? "error"
                                        : inputState.description
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.description && (
                                    <span className="error-message">{errors.description}</span>
                                )}
                            </div>



                            {/* <div title="Due Date" className="flex-column">
                                <label
                                    htmlFor="due_date"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Due Date<span className="required">*</span>
                                </label>
                                <input
                                    id="due_date"
                                    type="date"
                                    name="due_date"
                                    onChange={handleInputChange}
                                    value={formData.due_date}
                                    className={`form-input ${errors.due_date
                                        ? "error"
                                        : inputState.due_date
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.due_date && (
                                    <span className="error-message">{errors.due_date}</span>
                                )}
                            </div> */}

                            {/* <div title="Assigned By Name" className="flex-column">
                                <label
                                    htmlFor="assigned_by_name"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Customer Name<span className="required">*</span>
                                </label>
                                <input
                                    id="assigned_by_name"
                                    type="text"
                                    name="assigned_by_name"
                                    maxLength={150}
                                    placeholder="Enter Assigned By Name"
                                    onChange={handleInputChange}
                                    value={formData.assigned_by_name}
                                    className={`form-input ${errors.assigned_by_name
                                        ? "error"
                                        : inputState.assigned_by_name
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.assigned_by_name && (
                                    <span className="error-message">
                                        {errors.assigned_by_name}
                                    </span>
                                )}
                            </div>

                            <div title="Assigned By" className="flex-column">
                                <label
                                    htmlFor="assigned_by"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Customer Email<span className="required">*</span>
                                </label>
                                <input
                                    id="assigned_by"
                                    type="email"
                                    name="assigned_by"
                                    placeholder="Enter Email"
                                    onChange={handleInputChange}
                                    onInput={(e) => {
                                        e.target.value = e.target.value.toLowerCase().trim(); // Convert input to lowercase
                                    }}
                                    value={formData.assigned_by}
                                    className={`form-input ${errors.assigned_by
                                        ? "error"
                                        : inputState.assigned_by
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.assigned_by && (
                                    <span className="error-message">{errors.assigned_by}</span>
                                )}
                            </div> */}

                            <div title="Description" className="flex-column">
                                <label
                                    htmlFor="description"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Add Screenshot<span className="required">*</span>
                                </label>

                                <div className="flex-row justify-between">
                                    <div >
                                        <label htmlFor={`document`} className="svg-icon">
                                            <div className="svg-field  align-center">
                                                <Attachment />
                                            </div>

                                        </label>
                                        <input
                                            type="file"
                                            id={`document`}
                                            name="document"
                                            accept=".zip, .pdf, .xls, .xlsx"
                                            style={{ display: "none" }}
                                            onChange={handleFileChange}
                                        />
                                    </div>
                                    <div style={{ width: "6vw" }}>

                                        <span className="file-name">
                                            {fileName}
                                        </span>
                                    </div>
                                    {fileName &&
                                        <div className="flex-row justify-between" style={{ width: "12vw" }}>
                                            <button title="Clear File" onClick={handleClear} className="file-clear clear-button">
                                                Clear
                                            </button>

                                        </div>
                                    }
                                </div>
                            </div>



                            <div className="button-models">
                                <button
                                    className="model-button model-button-cancel font-weight500"
                                    type="button"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Raise Request
                                </button>
                            </div>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (

                                    <h6 className="text-center">
                                        {Object.keys(errors).map((field) =>
                                            field.charAt(0).toUpperCase() + field.slice(1)
                                        ).join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const CloseRequest = ({ id, getData }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setFormData({
            is_resolved: "",
        })
        setShow(false);
    }
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        is_resolved: "",
    });



    console.log(formData);
    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["is_resolved"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleFormSubmitPut = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(`${BASE_URL}/ticket/ticketclose/${id}/`, {
                    is_resolved: true,

                    close_by: sessionStorage.getItem('email'),
                });

                if (res.status === 200) {
                    await getData();
                    handleClose();
                } else {
                    alert(res);
                }
            } catch (err) {
                //   handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div className="" >
                <button className=" model-button-black  my-5px font-weight500" onClick={handleShow}>
                    Close Ticket
                </button>
            </div>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="flex-column">
                                <label htmlFor="is_resolved" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                    Ticket Closing Remark
                                </label>
                                <textarea
                                    id="is_resolved"
                                    type="text"
                                    name="is_resolved"
                                    placeholder="Remarks"
                                    onChange={handleInputChange}
                                    maxLength={100}
                                    value={formData.is_resolved}
                                    className={`form-input-textarea   font-weight400  font-size-subheading ${errors.is_resolved
                                        ? "error"
                                        : inputState.is_resolved
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.is_resolved && (
                                    <span className="error-message font-size-text ">{ }</span>
                                )}
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel   font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-delete    font-size-heading"
                                    onClick={handleFormSubmitPut}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};


const ViewTicket = () => {

    const navigate = useNavigate()
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split('/');
    const backUrl = "/" + urlParts[3] + `/ticketSystem`;

    const location = useLocation();
    const { i } = location.state;

    console.log("i")
    console.log(i)
    const backroute = () => {
        navigate(backUrl)
    }

    const [buffer, setBuffering] = useState(true); //buffering logic
    const [ticket, setTicketData] = useState([]);
    const [ticketChat, setTicketChat] = useState([]);

    const getTicketDetails = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const ticket = await axios.get(`${BASE_URL}/ticket/ticket/${i}/`);
            setTicketData(ticket.data);
            const chat = await axios.get(`${BASE_URL}/ticket/ticketChat-by-ticket/${i}/`);
            setTicketChat(chat.data);
        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getTicketDetails();
    }, []);


    const getTicketChat = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {

            const res = await axios.get(
                `${BASE_URL}/ticket/ticketChat-by-ticket/${i}/`
            );
            setTicketChat(res.data);
        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    return (
        <>
            <Dashboardnavbar name={"Ticket Details"} url="Ticket Managment" />
            <div className="content-tabs">
                <>

                    <div className=" ">

                        <div className="flex-row justify-between mb-20">
                            <button className=" model-button-black font-weight500" onClick={backroute}>Back</button>
                            {
                                ticket.status !== "completed" &&
                                <CloseRequest id={ticket.id} getData={getTicketDetails} />
                            }

                        </div>


                        <div className="table-css-white-background ">
                            <div className="flex-row justify-between">
                                <h2>
                                    Ticket ID: {ticket.id}
                                </h2>
                                <h4>
                                    <span
                                        className="priority-button behavior"
                                        data-status={ticket.status}
                                    >
                                        {ticket.status ? ticket.status.toUpperCase() : ''}
                                    </span>
                                </h4>
                            </div>
                            <div class="ticket-date">
                                Date Submitted:{" "}
                                {formattedDateLong(ticket.assign_date)}
                            </div>

                            <div class="ticket-desc-header">Title: "{ticket.title}"</div>
                            <hr />
                            <div className="ticket-desc">
                                <div class="ticket-desc-header">Description of Issue</div>
                                <p>{ticket.description}</p>
                            </div>
                        </div>
                        <hr />
                        <div className="table-css-white-background ">
                            <div className="flex-row justify-between">
                                <h3>
                                    Chat History:
                                </h3>
                                <TicketChatboxModal i={i} clientemail={ticket.assigned_by}
                                    clientname={ticket.assigned_by_name}
                                    ticket_name={ticket.title}
                                    status={ticket.status}
                                    getAllTasks={getTicketDetails}
                                    productname={ticket.ticket_for}

                                />

                            </div>

                            <ul className="chatbox">
                                {buffer ? (
                                    <div className="spinner"></div>
                                ) : ticketChat.length === 0 ? (
                                    <div
                                        className="align-center justify-center "
                                        style={{ alignSelf: "center" }}
                                    >
                                        - No Chat Historys 🪹 -
                                    </div>
                                ) : (
                                    <>
                                        {ticketChat
                                            .sort(
                                                (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
                                            )
                                            .map((i, index) => (
                                                <>
                                                    {i.sender == sessionStorage.getItem("email") ? (
                                                        <>
                                                            <p className="chat-reply-timestamp font-size-text">
                                                                {i.sender_name}
                                                            </p>
                                                            <div className="chat chat-reply">
                                                                <li className="p-li">
                                                                    {i.message ? (
                                                                        <>
                                                                            <p>{i.message}</p>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <ViewChatImageorFile
                                                                                textcss={'chat-photo-reply'}
                                                                                filesrc={i.document}
                                                                            />
                                                                        </>
                                                                    )}

                                                                </li>
                                                                <p className="chat-reply-timestamp pad-r text-right font-size-label">
                                                                    {formatDateTime(i.timestamp).full}
                                                                </p>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <p className="chat-incoming-timestamp font-size-text ">
                                                                {i.sender_name}
                                                            </p>
                                                            <div className="chat chat-incoming">
                                                                <li className="p-li">
                                                                    {i.message ? (
                                                                        <>
                                                                            <p>{i.message}</p>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <ViewChatImageorFile
                                                                                textcss={'chat-photo-incoming'}
                                                                                filesrc={i.document}
                                                                            />
                                                                        </>
                                                                    )}


                                                                </li>
                                                                <p className="chat-incoming-timestamp pad-r text-right font-size-label">
                                                                    {formatDateTime(i.timestamp).full}
                                                                </p>
                                                            </div>
                                                        </>
                                                    )}
                                                </>
                                            ))}
                                    </>
                                )}
                            </ul>
                        </div>
                    </div>

                </>
            </div>
        </>
    );
};

const MyTickets = () => {
    const [buffer, setBuffering] = useState(true); //buffering logic
    const [show, setShow] = useState(false);
    const [indexRow, setIndexRow] = useState({});
    const handleClose = () => setShow(false);
    const handleShow = (e) => {
        setShow(true);
        setIndexRow(e);
    };
    // *********** Employee Details Api Start ***********
    const [ticketsList, setTicketsList] = useState([]);
    const [filteredTicketsList, setFilteredTicketsList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState("pending");

    const getAllTicketsList = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/ticket/ticket-assigned-by/${sessionStorage.getItem("email")}/${selectedStatus}/`
            );
            setTicketsList(res.data);

            const uniqueDayStatus = [
                ...new Set(res.data.map((entry) => entry.status)),
            ];
            setStatus_list(uniqueDayStatus);
            const uniquePriorityStatus = [
                ...new Set(res.data.map((entry) => entry.priority)),
            ];
            setPriority_status(uniquePriorityStatus);
        } catch (err) {
            // handleErrorToast(err)
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };
    useEffect(() => {
        getAllTicketsList();
    }, [selectedStatus]);

    // *********** Employee Details Api End ***********

    const [startdate, setStartDate] = useState("");

    const [enddate, setEndDate] = useState("");

    // *********** Filter Logic ***********

    const [status_list, setStatus_list] = useState([]);
    const [asignee, setAsignee] = useState("");
    const [asigning, setAsigning] = useState("");
    const [priority, setPriority] = useState("");
    const [priority_status, setPriority_status] = useState([]);


    useEffect(() => {
        if (startdate === null && enddate === null) {
            setStartDate("");
            setEndDate("");
        }
    }, [startdate, enddate]);

    function handlePriority(value) {
        if (value == 1) {
            return (
                <button className="priority-button font-weight600 Color-tab-red">
                    High
                </button>
            );
        } else if (value == 2) {
            return (
                <button className="priority-button font-weight600 Color-tab-yellow">
                    Medium
                </button>
            );

        } else if (value == 3) {
            return (
                <button className="priority-button font-weight600 Color-tab-blue">
                    Low
                </button>
            );
        } else return <td className="align-center"></td>;
    }

    const handleSearch = () => {
        let filteredData = ticketsList;

        if (priority !== "") {
            if (priority === "1") {
                filteredData = filteredData.filter(
                    (employee) => employee.priority === priority
                );
            } else if (priority === "2") {
                filteredData = filteredData.filter(
                    (employee) => employee.priority === priority
                );
            } else if (priority === "3") {
                filteredData = filteredData.filter(
                    (employee) => employee.priority === priority
                );
            }
        }
        if (asignee) {
            const lowercaseSelectedName = asignee.toLowerCase();
            filteredData = filteredData.filter((employee) => {
                const assigneeNameMatch = employee.assigned_by_name
                    .toLowerCase()
                    .includes(lowercaseSelectedName);

                const assigneeEmailMatch = employee.assigned_by
                    .toLowerCase()
                    .includes(lowercaseSelectedName);

                const title = employee.title
                    .toLowerCase()
                    .includes(lowercaseSelectedName);

                const description = employee.description
                    .toLowerCase()
                    .includes(lowercaseSelectedName);

                return (
                    assigneeNameMatch || assigneeEmailMatch || title || description
                );
            });
        }

        if (startdate !== "" && enddate !== "") {
            filteredData = filteredData.filter(
                (employee) =>
                    employee.assign_date >= startdate && employee.assign_date <= enddate
            );
        } else if (startdate !== "") {
            filteredData = filteredData.filter(
                (employee) => employee.assign_date >= startdate
            );
        } else if (enddate !== "") {
            filteredData = filteredData.filter(
                (employee) => employee.assign_date <= enddate
            );
        }



        setFilteredTicketsList(filteredData);
    };

    useEffect(() => {
        handleSearch();
    }, [
        selectedStatus,
        ticketsList,
        asignee,
        startdate,
        enddate,
        asigning,
        priority,
    ]);

    const statusName = [
        {
            status: "open",
            name: "Open",
        },
        {
            status: "acceptance",
            name: "Acceptance",
        },
        {
            status: "pending",
            name: "Pending",
        },
        {
            status: "inprocess",
            name: "In Process",
        },
        {
            status: "completed",
            name: "Completed",
        },
        {
            status: "close",
            name: "Close",
        },
    ];

    const options = statusName.map((e) => ({
        value: e.status,
        label: e.name,
    }));

    const handleChangecc = (selected) => {
        const multipleperson =
            selected.length > 0 ? selected.map((item) => item.value) : "";
        setSelectedStatus(multipleperson);
    };

    const createMarkup = (content) => {
        const linkRegex = /(?:https?|ftp):\/\/[^\s]+/g;
        return {
            __html: content.replace(linkRegex, (url) => {
                return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
            }),
        };
    };

    const navigate = useNavigate();
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const ticketUrl = "/" + urlParts[3] + "/ticket/";
    const ViewTicketDetails = (i) => {
        navigate(ticketUrl + i + '/', { state: { i } });
    };


    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <div className="content-tabs">
                <Dashboardnavbar url="My Ticket" name={"MY Ticket"} />
                <div className="bloc-tabss2  wfm-margin">
                    {/* <button
                        className={"dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs dashboardcomponent-tabs  font-weight400  font-size-subheading   "}

                    >
                        My Tickets
                    </button> */}


                </div>
                <div className="attendance-subcont">
                    <div className="field-cont">
                        {/* <div className="field-cont-div">
                            <input
                                className="attendance-input-field width-10vw   date-field"
                                placeholder="From Date"
                                type="date"
                                value={startdate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                            <hr className="field-cont-hr" />
                        </div> */}
                        {/* <div className="field-cont-div">
                            <input
                                className="attendance-input-field width-10vw   date-field"
                                placeholder="To Date"
                                type="date"
                                value={enddate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                            <hr className="field-cont-hr" />
                        </div> */}
                        <div title=' Date Range' className="field-cont-div " >

                            <DateRangePicker startDate={startdate} endDate={enddate} placeHolder1="From Date" placeHolder2="To Date" style={{ color: "black" }} onChange={(start, end) => {
                                setStartDate(start);
                                setEndDate(end);

                            }} />
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw   date-field"
                                type="text"
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.target.value)}
                            >
                                <option value="null">All</option>
                                {status_list.map((status) => (
                                    <option value={status}>{status}</option>
                                ))}
                            </select>
                            <hr className="field-cont-hr" />

                        </div>

                        <div className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw   date-field"
                                type="text"
                                value={priority}
                                onChange={(e) => setPriority(e.target.value)}
                            >
                                <option value="">Priority</option>
                                {priority_status
                                    .sort((a, b) => a - b)
                                    .map((prior) => (
                                        <option value={prior}>
                                            {prior === "1"
                                                ? "High"
                                                : prior === "2"
                                                    ? "Medium"
                                                    : prior === "3"
                                                        ? "Low"
                                                        : "All"}
                                        </option>
                                    ))}
                                ;
                            </select>
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div-svg">
                            <SearchBig />
                            <input
                                className="attendance-input-field width-15vw  "
                                placeholder="By Task, Emp & Name"
                                type="text"
                                value={asignee}
                                onChange={(e) => setAsignee(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="btn-cont">
                        <RaiseATicket getTicketList={getAllTicketsList} />
                        {/* <RaiseTicketWithDocument getTicketList={getAllTicketsList} /> */}
                    </div>
                </div>

                <div className="table-css-white-background">
                    <table className="table-css-ticket table-fixed w-full">
                        <thead>
                            <tr className="custom-table-head-tr">
                                <th className="w-1/10 align-left">Sr no.</th>
                                <th className="w-1/10 align-left">Request By</th>
                                <th className="w-1/10 align-center">Title</th>
                                <th className="w-1/10 align-center">Task</th>
                                <th className="w-1/10 align-center">Assigned Date</th>
                                <th className="w-1/10 align-center">Due date</th>
                                <th className="w-1/10 align-center">Chat History</th>
                                {/* <th className="w-1/10 align-center">Priority</th> */}
                                <th className="w-1/10 align-center">Status</th>
                                <th className="w-1/10 text-right">Action</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <div className="spinner"></div> //buffering logic
                        ) : (
                            <tbody>
                                {filteredTicketsList
                                    .sort((a, b) => new Date(a.due_date) - new Date(b.due_date))
                                    .sort((a, b) => a.priority - b.priority)
                                    .map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="custom-table-head-td">
                                                <td className="w-1/10 align-left">{index + 1}</td>
                                                <td className="w-1/10 align-left">
                                                    {i.assigned_by_name} <br /> {i.assigned_by}
                                                </td>
                                                <td className="w-1/10 align-center">{i.title}</td>
                                                <td className="w-1/10 align-center">
                                                    <div dangerouslySetInnerHTML={createMarkup(i.description)} />
                                                </td>
                                                <td className="w-1/10 align-center">{formatDate(i.assign_date)}</td>
                                                <td className="w-1/10 align-center">{formatDate(i.due_date)}</td>
                                                <td className="w-1/10 align-center">
                                                    {i.remarks?.map((edata, index) => (
                                                        <div key={index}>
                                                            By : {edata.name}
                                                            <br />
                                                            On: {formatDate(edata.created_at)}
                                                            <br />
                                                            {edata.remark_text}
                                                        </div>
                                                    ))}

                                                    <TicketChatboxModal i={i.id} getAllTasks={getAllTicketsList} clientemail={i.assigned_by}
                                                        clientname={i.assigned_by_name}
                                                        ticket_name={i.title}
                                                        status={i.status} />

                                                </td>
                                                {/* <td className="w-1/10 align-center">
                                                    {i.priority ? handlePriority(i.priority) : '-'}
                                                </td> */}
                                                <td className="w-1/10 align-center">{i.status}</td>
                                                <td className="w-1/10 text-right">
                                                    <button
                                                        className=""
                                                        title="View Ticket Details"
                                                        onClick={() => ViewTicketDetails(i.id)}
                                                    >
                                                        <Eye />
                                                    </button>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
        </>
    );
};

export { MyTickets, ViewTicket }